import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Modal } from 'components/ui';

type QrCodeInfoModalProps = {
  onClose: () => void;
};

const QrCodeInfoModal: React.FC<QrCodeInfoModalProps> = ({ onClose }) => (
  <Modal
    open
    className="max-w-modal"
    title={
      <div role="heading" aria-level={2} data-testid="qr-info-modal-title" className="text-icon font-bold">
        <FormattedMessage id="login.qrCodeInfoModal.title" defaultMessage="QR code" />
      </div>
    }
  >
    <div className="flex flex-col gap-9 items-center">
      <div data-testid="qr-info-description" className="text-center text-s text-low">
        <FormattedMessage
          id="login.qrCodeInfoModal.description"
          defaultMessage="Please check your inbox for the email containing your QR code, then scan it to the kiosk to access your appointment."
        />
      </div>
      <Button onClick={onClose} testId="qr-code-ok-button" className="w-full">
        <FormattedMessage id="ok" defaultMessage="Ok" />
      </Button>
    </div>
  </Modal>
);

export default QrCodeInfoModal;
